// extracted by mini-css-extract-plugin
module.exports =  {"root":"GsDHJj7qo3SsWwf2o5oo"};